import {CitySlug, citySlugToInvestmentsMapCityQuery, mapParamSlugToCitySlug} from "../../../../../config/cities";
import {AppDispatch} from "../../../store/store";
import {IRegionAutocompleteItem} from "../../map/api/charts_regions_api";
import {setChartsSelectedRegion, setMapCityPocCityQuery} from "../../map/redux/map_city_poc_slice";
import {isRpRegionDistrictParentType} from "../../map/types/rp_region_type";
import {resolveMapRegionParamsFromSelection} from "../../map/utils/resolve_map_region_params_from_selection";
import {MapRegionSearchOption, toMapRegionSearchOption} from "./map_region_search_option";

/** BE default is 10 and max is 50 — voivodeship-wide permissions need the ceiling. */
export const PERMITTED_REGION_AUTOCOMPLETE_ARGS = {permitted: 1 as const, limit: 50};

const regionToLabel = (region: IRegionAutocompleteItem) =>
    region.name ?? region.short_name ?? region.full_name_reverted ?? region.slug;

const regionToSubtitle = (region: IRegionAutocompleteItem, label: string) => {
    const subtitle = region.full_name_reverted ?? region.short_name ?? "";

    if (!subtitle || subtitle === label) {
        return null;
    }

    return subtitle;
};

export const mapRegionsToOptions = (regions: IRegionAutocompleteItem[]): MapRegionSearchOption[] =>
    regions.map((region) => {
        const citySlug = mapParamSlugToCitySlug(region.slug);
        const label = regionToLabel(region);

        return toMapRegionSearchOption(region, citySlug, label, regionToSubtitle(region, label));
    });

export const sortPermittedRegionOptions = (options: MapRegionSearchOption[]): MapRegionSearchOption[] =>
    [...options].sort((left, right) => {
        const leftRank = isRpRegionDistrictParentType(left.region.type) ? 0 : 1;
        const rightRank = isRpRegionDistrictParentType(right.region.type) ? 0 : 1;

        return leftRank - rightRank;
    });

export const applyRegionSelection = (
    dispatch: AppDispatch,
    region: IRegionAutocompleteItem,
    label: string,
    citySlug: CitySlug | null
) => {
    const mapParams = resolveMapRegionParamsFromSelection(region);
    const cityQuery = citySlug != null ? citySlugToInvestmentsMapCityQuery(citySlug) : label;

    dispatch(
        setChartsSelectedRegion({
            regionId: region.id,
            slug: region.slug,
            citySlug,
            label,
            hasChartsAccess: region.has_charts_access,
            ...mapParams
        })
    );
    dispatch(setMapCityPocCityQuery(cityQuery));
};
